export const FETCH_PARTY_REQUEST = "FETCH_PARTY_REQUEST";
export const FETCH_PARTY_SUCCESS = "FETCH_PARTY_SUCCESS";
export const FETCH_PARTY_FAILURE = "FETCH_PARTY_FAILURE";
